import React from "react";

import ongData from '../scripts/formOng';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/system/Unstable_Grid';
import Container from '@mui/material/Container';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const AccordionOdd = ({oddOptions, servicesOdd, handleServicesOddChange}) => {

    const findSousService = (label) => {
        for (let i = 0; i < ongData.services.length; i++) {
            if (ongData.services[i].label === label) return ongData.services[i].sous_service;      
        }

        return null;
    }

    const handleSelection = (service, value, checked, childValues = []) => {
        const currentValues = servicesOdd[service] || [];

        if (checked) {
            const updatedServicesOdd = {
                ...servicesOdd,
                [service]: currentValues.includes(value) ? currentValues : [...currentValues, value]
            };
            handleServicesOddChange(updatedServicesOdd);
        } else {
            const updatedServicesOdd = {
                ...servicesOdd,
                [service]: currentValues.filter(item => item !== value && !childValues.includes(item))
            };
            handleServicesOddChange(updatedServicesOdd);
        }
    };

    const isSelected = (service, value) => servicesOdd[service]?.includes(value) || false;

    return (
        <Container sx={{ mt: 5 }}>
            <Grid container spacing={2}>
                {oddOptions.map((x, index) => (
                    <Grid xs={6} key={index}>
                        <Accordion slotProps={{ transition: { unmountOnExit: true } }} key={index}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index + 1}-content`}
                                id={`panel${index + 1}-header`}
                            >
                                {x}
                            </AccordionSummary>
                            <AccordionDetails>
                                {findSousService(x).map((y, innerIndex) => {
                                    const childValues = y.options?.map((option) => `${y.value}::${option.value}`) || [];

                                    return (
                                        <FormGroup key={innerIndex}>
                                            <FormControlLabel
                                                control={
                                                <Checkbox
                                                    value={y.value}
                                                    onChange={(event) => { handleSelection(x, event.target.value, event.target.checked, childValues); }}
                                                    checked={isSelected(x, y.value)}

                                                />}
                                                label={y.label}
                                            />
                                            {y.options && isSelected(x, y.value) && (
                                                <FormGroup sx={{ ml: 4 }}>
                                                    {y.options.map((option, optionIndex) => (
                                                        <FormControlLabel
                                                            key={optionIndex}
                                                            control={
                                                            <Checkbox
                                                                value={`${y.value}::${option.value}`}
                                                                onChange={(event) => { handleSelection(x, event.target.value, event.target.checked); }}
                                                                checked={isSelected(x, `${y.value}::${option.value}`)}
                                                            />}
                                                            label={option.label}
                                                        />
                                                    ))}
                                                </FormGroup>
                                            )}
                                        </FormGroup>
                                    );
                                })}
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                ))}
            </Grid>
        </Container>
    )
};

export default AccordionOdd;
